const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-email",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconS-email1",
    serifid: "iconS-email"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.005,21.069c-0.001,0.005 -0.002,0.01 -0.003,0.015c-0.115,-0.009 -0.206,-0.106 -0.206,-0.224l0.002,0.002c0.014,0.1 0.093,0.179 0.192,0.192l0.015,0.015Zm-0.209,-0.209c0,0.687 -0.612,1.231 -1.292,1.127c-5.467,-0.792 -9.501,-6.044 -8.342,-11.949c0.766,-3.915 3.919,-7.071 7.834,-7.839c6.429,-1.259 12.041,3.62 12.041,9.873l0,0.895c0,0.001 0,0.003 0,0.004c0.037,1.906 -1.209,3.747 -3.086,4.182c-0.001,0 -0.003,0 -0.004,0.001c-1.798,0.456 -3.477,-0.251 -4.454,-1.525c-0.037,-0.048 -0.091,-0.079 -0.151,-0.087c-0.06,-0.007 -0.12,0.01 -0.167,0.048c-0.783,0.626 -1.762,1.017 -2.841,1.017c-2.741,-0 -4.917,-2.41 -4.529,-5.229c0.228,-1.663 1.428,-3.099 3.011,-3.66c1.299,-0.46 2.499,-0.287 3.513,0.209c0.06,0.029 0.129,0.031 0.19,0.004c0.061,-0.027 0.106,-0.08 0.124,-0.143c0.056,-0.192 0.223,-0.338 0.433,-0.338l1.37,-0c0.255,-0 0.461,0.206 0.461,0.461l0,5.146c0,1.07 0.87,1.94 1.939,1.94c1.068,0 1.938,-0.87 1.938,-1.94l-0,-0.693c-0,-4.053 -2.962,-7.681 -6.998,-8.072c-4.623,-0.445 -8.532,3.199 -8.532,7.738c0,3.886 2.862,7.113 6.583,7.685c0.55,0.085 0.959,0.555 0.959,1.117l0,0.028Zm-0.502,-6.508c1.302,0 2.281,-1.024 2.281,-2.283c-0,-1.258 -1.023,-2.283 -2.281,-2.283c-1.258,0 -2.281,1.025 -2.281,2.283c-0,1.259 1.023,2.283 2.281,2.283Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSEmail);
export default __webpack_public_path__ + "static/media/iconS-email.cc8bf6bb2d4ccf80af31382ca64cbd46.svg";
export { ForwardRef as ReactComponent };